import { useState } from 'react';

const textarea = 'h-[28rem] w-full rounded border-2 border-ink bg-white p-2 font-mono text-xs';
const btn = 'rounded border-2 border-ink px-3 py-1 text-sm font-semibold hover:bg-caption/50';

/**
 * A raw JSON editor for one value: the escape hatch for anything without a form. Mount it with a key per value so its
 * text starts fresh. Changes apply to the draft only on "Apply to draft".
 */
export function JsonEditor({
  label,
  value,
  onApply,
}: {
  label: string;
  value: unknown;
  onApply: (parsed: unknown) => string | null;
}) {
  const [text, setText] = useState(() => JSON.stringify(value, null, 2));
  const [error, setError] = useState<string | null>(null);

  const apply = () => {
    try {
      setError(onApply(JSON.parse(text)));
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    }
  };

  return (
    <>
      <textarea
        aria-label={label}
        value={text}
        onChange={(e) => setText(e.target.value)}
        className={textarea}
        spellCheck={false}
      />
      {error && <p className="mt-1 text-sm text-blam">{error}</p>}
      <div className="mt-2 flex gap-2">
        <button type="button" onClick={apply} className={`${btn} bg-benday`}>
          Apply to draft
        </button>
      </div>
    </>
  );
}
